import QRCode from "react-qr-code";
import "./qr-generator.scss";

function formatQuick(isoStr) {
  const date = new Date(isoStr);
  const options = {
    timeZone: 'Asia/Singapore',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: 'numeric', minute: '2-digit', second: '2-digit',
    hour12: true
  };
  const formatter = new Intl.DateTimeFormat('en-GB', options); // DD/MM/YYYY
  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
  return `Last Updated: ${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}:${parts.second} ${parts.dayPeriod}`;
}

function QrGenerator({ qrData, description, useTemplate, qrUpdatedAt }) {
  const descriptionStyle = useTemplate ? "qrDescription" : "productName";
  const containerStyle = useTemplate ? "templateComponent" : "qrComponent";
  const productType = useTemplate ? qrData.fuelType || qrData.productType || null : null;
  const isLubes = (qrData.productType ?? qrData.fuelType) === "lubes";
  const isSeagas = (qrData.productType ?? qrData.fuelType) === "seagas";
  const isSeacharge = (qrData.productType ?? qrData.fuelType) === "seacharge";
  let contentStyle = isLubes || isSeagas || isSeacharge ? "longLubeText" : "longText";
  if (description.length <= 29) {
    contentStyle = isLubes || isSeagas || isSeacharge ? "shortLubeText" : `shortText`;
  }
  let qrClassName = "qrImage"
  if (isSeacharge && useTemplate) {
    qrClassName += "SeaChargeQr";
  }
  return (
    <div className={"internalDiv"} >
      <div className="qrOuterRing">
        <div className={[containerStyle, productType].join(" ")}>
          <div className={qrClassName}>
            <QRCode size={149.76} value={JSON.stringify(qrData)} />
          </div>
          {
            <div className={descriptionStyle}>
              {useTemplate ? <p className={contentStyle}>{description}</p> : description}
            </div>
          }
        </div>
      </div>
      {qrUpdatedAt && <p className="lastUpdatedText" >{formatQuick(qrUpdatedAt)}</p>}
    </div>
  );
  // return (
  //   <div className={"qrComponentContainer"}>
  //     <div className={[containerStyle, productType].join(" ")}>
  //       <div className={descriptionStyle + "Qr"}>
  //
  //       </div>
  //       {descriptionComponent}
  //     </div>
  //   </div>
  // )
}

export default QrGenerator;
